<template>
  <b-card no-body :id="'widgetppt' + widget.id">
    <div class="card-header" :class="{fixedCardHeader: isOverflown}">
      <span v-b-tooltip.hover :title="title" class="widget-title">{{title}}</span>
      <settings-button />
    </div>
    <b-card-body class="p-3 clearfix" @click="handleClickThrough">
      <div v-if="loaded === true" class="text-muted text-center text-uppercase font-weight-bold font-xs">
        <canvas ref='chartNode' style="width: 100%; height: auto; max-width: 500px;"></canvas>
        <div class="row">
          <div class="col-sm"> {{ formattedValues.minValue }} </div>
          <div class="col-sm"> {{ formattedValues.value }} </div>
          <div class="col-sm"> {{ formattedValues.maxValue }} </div>
        </div>
        <div>{{ title }}</div>
      </div>
      <div v-else>
        <div class="h5 text-center p-2 loading-text">{{loadMessage}}</div>
      </div>
    </b-card-body>
    <div class="comparison-disclaimer" v-if="this.widget.disableDataComparison"><sup>*</sup>Data comparison unavailable</div>
  </b-card>
</template>

<script>
import { Gauge } from 'gaugeJS'
import { base_widget } from '@/views/widgets/base_widget'
import SettingsButton from '@/views/buttons/SettingsButton'

export default {
  name: 'GaugeWidget',
  mixins: [base_widget],
  components: {
    SettingsButton,
    Gauge
  },

  data () {
    return {
      value: 'Loading...',
      maxValue: 0,
      minValue: 0,
      loaded: false,
      loadMessage: 'Loading...',
      formattedValues: {
        value: 'Loading...',
        maxValue: '0',
        minValue: '0'
      }
    }
  },

  methods: {
    setData (response){
      var data = response.data.data
      var isLoaded = data.hasOwnProperty('value')
      if (isLoaded === false || typeof isLoaded === 'undefined') {
        this.loadMessage = 'No Data Available'
        this.saveWidgetData({}, [])
      } else {
        this.loaded = true
        this.value = data.value
        this.maxValue = data.maxValue
        this.minValue = data.minValue
        this.formattedValues = data.formatted_values
        this.$nextTick(function() {
          this.createChart()
        })
        this.saveWidgetData([
          this.value,
          this.minValue,
          this.maxValue,
          this.formattedValues
          ],
          [
            'value',
            'minValue',
            'maxValue',
            'formattedValues'
          ]
        )
      }
    },

    createChart () {
      var opts = {
        angle: 0.05, // The span of the gauge arc
        lineWidth: 0.44, // The line thickness
        radiusScale: 1,
        pointer: {
          length: 0.9, // Relative to gauge radius
          strokeWidth: 0.035 // The thickness
        },
        colorStart: '#6FADCF',
        colorStop: '#8FC0DA',
        strokeColor: '#E0E0E0',
        highDpiSupport: true
      }
      var target = this.$refs.chartNode
      if (typeof target !== 'undefined') {
        var gauge = new Gauge(target).setOptions(opts)
        gauge.maxValue = this.maxValue
        gauge.setMinValue(this.minValue)
        gauge.set(this.value)
      }
    }
  }
}
</script>

<style scoped lang='sass'>
  .loading-text
    color: #757575
    text-align: center
    margin-top: 10px
    text-transform: uppercase
    font-family: 'Cooper Hewitt Semibold'
    letter-spacing: 3px
</style>
